import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Profissional, ProfissionalService } from '@app/features-modules/bolsa-de-profissionais/api';
import { Button } from 'primeng/button';
import { AvatarModule } from 'primeng/avatar';
import { getInitials } from '@shared/pipes/initials.pipe';

@Component({
  selector: 'app-card-perfil',
  imports: [CommonModule, Button, AvatarModule],
  templateUrl: './card-perfil.component.html',
  styleUrl: './card-perfil.component.scss',
})
export class CardPerfilComponent implements OnInit{
  imageError = false;

  getInitials(name?: string | null): string {
    return getInitials(name);
  }

private  profissionalService = inject(ProfissionalService);

  route = inject(ActivatedRoute);
  router = inject(Router);

  perfil: any = {};
  perfilDetail: any;
  dadosPessoais = input<Profissional>();
  @Output() onCloseModal = new EventEmitter<boolean>();
  isLoading: boolean = false;

  ngOnInit(): void {
    if (this.userProfileId) {
      this.loadProfissionalById(this.userProfileId);
    }
  }

  get userProfileId():any {
    return this.route.snapshot.paramMap.get('id')
  }

  loadProfissionalById(userProfileId: any){
    this.isLoading = true;
    this.profissionalService.getProfissionalByIdIdGet(userProfileId).subscribe((result)=>{
      if (result?.retorno?.codigo === 200 && result.data) {
        this.perfilDetail = result.data;
      }

    })
    
  }


  closeModal() {
    this.onCloseModal.emit(true);
  }

}
